import React from 'react';
import { FormattedMessage } from 'react-intl';
import utils from '../../utils/utils';

const RoutePreview = ({ route, color, active, onClick }) => {
  return (
    <div onClick={onClick} className={`m-b-2 route-preview ${active ? 'm-active' : ''}`}>
      <div className="route-preview__color" style={{ backgroundColor: color }} />

      <h5 className="route-preview__name m-b-1">
        <FormattedMessage id={'route.preview.name'} values={{ routeId: route.id }} />
      </h5>

      <div className="route-preview__driver text-muted">
        <small>
          <FormattedMessage
            id={'route.preview.driver'}
            values={{
              driver: route.driver ? `🚚 ${route.driver.name}` : '-',
            }}
          />
        </small>
      </div>
      <div className="route-preview__stops text-muted">
        <small>
          <FormattedMessage
            id={'route.preview.stops'}
            values={{
              count: route.deliveries.length,
            }}
          />
        </small>
      </div>
      <div className="route-preview__pickup text-muted">
        <small>
          <FormattedMessage
            id={'route.preview.pickup'}
            values={{
              range: utils.getFormattedTimeRangeFromDateStrings({ from: route.pickupFrom, to: route.pickupTo }),
            }}
          />
        </small>
      </div>
      {route.isFinal ? (
        <div className="route-preview__locked m-t-2 text-muted">
          <small>
            <FormattedMessage id={'route.preview.locked'} />
          </small>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default RoutePreview;
